import styled from 'styled-components';
import { Collapse } from 'react-collapse';

export const CollapsibleDetails = styled(Collapse)`
  width: 100%;
`;
